/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { MdOutlineAccountCircle } from 'react-icons/md';
import {
  getUserAgentId,
  getObjectFromLS,
} from '../../shared/helper-utils/localStorage';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppLink from '../../shared/components/app-link/AppLink';
import { getAgentBalanceApi } from '../../api/profileApi';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  hideHeaderMenu,
  formatCurrency,
  showHeaderMenu,
} from '../../shared/helper-utils/appUtils';
import AccountsPageHorizontalBar from './accounts/AccountsPageHorizontalBar';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';

function AccountsPage() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const ACCOUNT_PAGES = [
    {
      name: formattedMessage('manage_bookings'),
      route: NAVIGATION_ROUTES.MANAGE_ALL_BOOKINGS,
    },
    {
      name: formattedMessage('my_bookings'),
      route: NAVIGATION_ROUTES.MY_BOOKINGS_ROUTE,
    },
    {
      name: formattedMessage('agent_ledger'),
      route: NAVIGATION_ROUTES.PROFILE.LEDGER,
    },
    { name: formattedMessage('reports'), route: '/reports' },
    {
      name: formattedMessage('add_view_staff'),
      route: NAVIGATION_ROUTES.PROFILE.STAFF_ROUTE,
    },
    {
      name: formattedMessage('agent_markup'),
      route: NAVIGATION_ROUTES.AGENT_MARKUP,
    },
    { name: 'Offline Payment', route: '/make-payment' },
    { name: 'Online Payment', route: '/balance-upload' },
    {
      name: 'Group Booking',
      route: NAVIGATION_ROUTES.FLIGHT.FLIGHT_GROUP_BOOKING,
    },
  ];
  const userProfile = getObjectFromLS(APP_USER_PROFILE);
  const navigate = useNavigate();
  const userAccountRef = useRef(undefined);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   hideHeaderMenu();
  //   return () => showHeaderMenu();
  // }, []);

  const getAgentBalance = async () => {
    setIsLoading(true);
    const response = await getAgentBalanceApi();
    if (response.ApiStatus.Status === 'OK') {
      const { Result = {} } = response.ApiStatus;
      const { UserAccount = {} } = Result;
      userAccountRef.current = UserAccount;
      setShowBalanceModal(true);
    }
    setIsLoading(false);
  };

  const handleCheckBalance = () => {
    if (userAccountRef.current === undefined) {
      getAgentBalance();
      return;
    }
    setShowBalanceModal(true);
  };
  return (
    <div className="accounts-page">
      <AccountsPageHorizontalBar selectedPage="my-bookings" />
      <AppLoading isLoading={isLoading} />
      <div className="accounts-page_container p-3">
        <div className="accounts-page_profile-container p-2 d-flex align-items-center">
          <div className="me-2">
            <MdOutlineAccountCircle className="profile-icon" />
          </div>
          <div className="d-flex flex-column">
            <span className="profile-name">
              {`${userProfile?.firstName} ${userProfile?.lastName}`}{' '}
              <small className="fw-500">({getUserAgentId()})</small>
            </span>
            <AppLink
              linkText={formattedMessage('check_balance')}
              onClick={handleCheckBalance}
              variant="secondary"
              className="fw-500"
            />
          </div>
        </div>
        <div className="d-flex flex-wrap">
          {ACCOUNT_PAGES.map((page) => (
            <button
              onClick={() => navigate(page.route)}
              key={page.name}
              className="account-tabs"
            >
              {page.name}
            </button>
          ))}
        </div>
      </div>
      {showBalanceModal && (
        <AppModal
          modalTitle={formattedMessage('balance_details')}
          backdrop="renderbackdrop"
          showCloseButton
          onModalClose={() => setShowBalanceModal(false)}
        >
          <div>
            <table>
              <tbody>
                <tr>
                  <th>{formattedMessage('available_balance')}</th>
                  <td>
                    :{' '}
                    {formatCurrency(
                      userAccountRef.current.Balance +
                        userAccountRef.current.CreditLimit -
                        userAccountRef.current.Due,
                    )}
                  </td>
                </tr>
                <tr>
                  <th>{formattedMessage('credit_limit')}</th>
                  <td>
                    : {formatCurrency(userAccountRef.current.CreditLimit)}
                  </td>
                </tr>
                <tr>
                  <th>{formattedMessage('due')}</th>
                  <td>: {formatCurrency(userAccountRef.current.Due)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </AppModal>
      )}
    </div>
  );
}

export default AccountsPage;
